'use strict';

import {DebuggableObject} from './DebuggableObject.js';
import * as Colors from './Colors.js';
import {post} from './Request.js';
import axios from 'axios';
import Cookies from 'js-cookie';
import {errorToast, successToast} from '../AppInterface/elements/Toasts/Toasts.js';
import $ from 'jquery';
import jQuery from 'jquery';
import {is_array, is_defined, is_function, is_object, is_string} from "../Helpers/js";

export class Browser extends DebuggableObject {
    constructor() {
        super('Browser', Colors.marsala);

        this.javascripts = [];
        this.stylesheets = [];

        this.defaults = {
            method: 'POST',
            async: true,
            timeout: 30000
        };
    }

    getLanguage() {
        let lang = $('html').attr('lang') || $('meta[http-equiv="language"]').attr('content');
        return lang || 'en';
    }

    // -------------------
    // Javascript Methods
    // -------------------
    scriptLoaded(url) {
        let scripts = Array.from(document.getElementsByTagName('script'));
        return scripts.filter(item => item.getAttribute('src') === url).length > 0 ||
            this.javascripts.filter(item => {
                item === url;
            }).length > 0;
    }

    addJavascript(url, id, noCache) {
        if (this.scriptLoaded(url)) {
            return this;
        }

        if (is_defined(jQuery)) {
            jQuery.ajax({
                url: url,
                async: false,
                cache: !noCache,
                ifModified: true,
                dataType: 'script',
                success: () => this.javascripts.push(url)
            });
        } else {
            let script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('src', url);
            if (id) {
                script.setAttribute('id', id);
            }
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }


    // ----------------
    // Request Handling
    // ----------------
    /**
     * JSON - Request with default error handling
     * async=false - NICHT MEHR VERWENDEN!!! DEPRECATED, BAD UIX, ONLY LEGACY!
     */
    send(url, data, onSuccess, onFailed, async = true, timeout) {
        // filter undefined values
        if (is_object(data)) {
            Object.entries(data).map(([key, value]) => {
                if (!is_defined(value)) {
                    delete data[key];
                } else if (is_array(value) && key.slice(-2) == '[]') {
                    // remove empty braces from arrays, those cause conflicts when stringify translates them
                    delete data[key];
                    data[key.slice(0, -2)] = value;
                }
            });
        } else if (is_string(data)) {
            data = $.deparam(data || '');
        }

        if (async) {
            post(url, data)
                .then((json) => {
                    let processed = onSuccess && onSuccess(json);

                    // legacy calls respond with a translated message from the server.
                    // we want to show this to the user
                    if (json && json.message && !processed) {
                        successToast(json.message);
                    }

                })
                .catch((json) => {
                    let processed = onFailed && onFailed(json);
                    // legacy calls respond with a translated message from the server.
                    // we want to show this to the user

                    const errors = json?.errors?.filter(err => err != 'serverTimeout') || []; //serverTimeout is handled in request.js
                    if (errors.length > 0 && !processed) {
                        errorToast(errors.join('<br>'));
                    }
                });
        } else { // sollte nur noch vom legacy-code gesetzt werden.
            data['csrf_token'] = Cookies.get(axios.defaults.xsrfCookieName);
            $.ajax({
                url: url,
                dataType: 'json',
                type: this.defaults.method,
                data: data,
                timeout: timeout || this.defaults.timeout,
                async: false,
                success: (json) => {
                    let processed = onSuccess && onSuccess(json);

                    // legacy calls respond with a translated message from the server.
                    // we want to show this to the user
                    if (json && json.message && !processed) {
                        successToast(json.message);
                    }
                },
                error: (request, status, error) => {
                    let json = {error: error};
                    if (is_object(request) && is_object(request.responseJSON)) {
                        json = request.responseJSON;
                    } else if (is_object(request) && is_defined(request.responseText)) {
                        json = {error: request.responseText};
                    }
                    let processed = onFailed && onFailed(json);
                    if (json && json.errors && !processed) {
                        errorToast(json.errors.join('<br>'));
                    }
                }
            });

        }

    }

    loadHTML($div, url, data, success, nosuccess) {
        this.send(
            url,
            data,
            function (json) {
                // if json.html is directly inserted, the <form>-tag will magically disappear
                $div.contents().detach();
                $div.append(json.html);

                if (is_function(success)) {
                    $div.each(function (index, domElement) {
                        success.call(domElement, json);
                    });
                }

            },
            nosuccess);
    }

    upload(url, data, fileInputId) {
        var formData = new FormData();
        var fileInput = document.getElementById(fileInputId);

        formData.append(fileInput.name, fileInput.files[0]);
        data.foreach((v, k) => formData.append(k, v));

        return post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    }

    download(url, filename) {
        // eslint-disable-next-line no-undef
        window.Browser.send('/tasks/' + taskId + '/download', null, function (result) {
            var blob = new Blob([result]);
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            // window.URL.revokeObjectURL(link.href);
        });
    }

    /**
     *  Resolves an Anchor/Link to POST
     */
    redirectPost(url, params, target) {
        target = target || '_self';

        let form = '<form action="' + url + '" method="POST" target="' + target + '">',
            p = is_string(params) ? $.deparam(params || '') : params || {};

        form += '<input type="hidden" name="csrf_token" value="' + Cookies.get(axios.defaults.xsrfCookieName) + '">';

        p.foreach((value, key) => {
            form += '<input type="hidden" name="' + key + '" value="' + value + '">';
        });
        form += '</form>';

        $(form).appendTo($(document.body)).submit();
    }

    // -------------------
    // Browser Methods
    // -------------------
    confirm(text) {
        return confirm(text);
    }

    prompt(text, predefined) {
        return prompt(text, predefined);
    }

    setErrorHandler(callback) {
        this.errorHandler = callback;
    }

}

export const browser = new Browser();